import { useDispatch } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import {
  handleParameterCreate,
  handleParameterOutputCreate,
} from "../../../abstract/redux/slice/structureSlice";
import { ButtonDefault } from "../../ui/buttons/ButtonDefault";
import styles from "./CanvasElementButton.module.scss";

function CanvasElementButton({ node, isGlobal }) {
  const dispatch = useDispatch();

  const _id = nodeUtils.getID(node);

  const handleAddMainParameterLogic = () => {
    dispatch(handleParameterCreate(_id));
  };

  const handleAddMainOutputParameterLogic = () => {
    dispatch(handleParameterOutputCreate(_id));
  };

  const getClass = () => {
    return `${styles["button"]}`;
  };

  return (
    <div className={getClass()}>
      {isGlobal ? (
        <div id="add_global_parameter">
          <ButtonDefault text={"add global\nparameter"} handler={handleAddMainParameterLogic} />
        </div>
      ) : (
        <div id="add_input_parameter">
          <ButtonDefault text={"add input\nparameter"} handler={handleAddMainParameterLogic} />
        </div>
      )}
      {!isGlobal && (
        <div id="add_output_parameter">
          <ButtonDefault
            text={"add output\nparameter"}
            handler={handleAddMainOutputParameterLogic}
          />
        </div>
      )}
    </div>
  );
}

export default CanvasElementButton;
